import React, { useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { Megaphone, X } from "lucide-react";

export default function BroadcastBar() {
  const { settings, feature } = useSettings();
  const [dismissed, setDismissed] = useState(false);

  if (!feature("broadcast") || !settings.broadcast_live || !settings.broadcast_text || dismissed) return null;

  return (
    <div className="bg-brand-terracotta text-white" data-testid="broadcast-bar">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2.5 flex items-center gap-3 text-sm">
        <Megaphone className="w-4 h-4 shrink-0" />
        <p className="flex-1 font-medium">{settings.broadcast_text}</p>
        <button onClick={() => setDismissed(true)} data-testid="broadcast-dismiss" className="shrink-0 opacity-80 hover:opacity-100"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
